import { postData } from "./../helper/server.js";
export const getData = async (payload) => {
  var data = {};
  if (payload.pathname == "/") {
    data.type = "home";
  } else {
    data.type = payload.pathname.substring(1);
  }

  if (payload.blog_type) data.blog_type = payload.blog_type;
  if (payload.id) data.id = payload.id;

  var response = await postData("data/get", data);
  return response.data;
};

export const sendContactUs= async (payload)=>{
    var response = await postData("contactus", payload);
    return response.data;
}

export const getTranslationPrice=async (payload)=>{
  var response = await postData("translationprice", payload);
  return response.data;
}
